// Voorleesknop op het bord: de schakelaar per gezinslid (readAloudApp.nl.ts).
export const appReadAloudDe = {
    setting: 'Vorlese-Taste auf der Tafel',
    settingHint: 'Eine große Taste liest Aufgaben, Termine und Nachrichten vor. Praktisch für alle, die noch nicht lesen.',
    language: 'Sprache für Vorlesen und Aufrufe',
    languageHint: 'Die Tafel liest Aufgaben, Termine und Aufrufe in dieser Sprache vor. Titel werden so vorgelesen, wie du sie eingibst.',
    languageBoard: 'Sprache der Tafel ({language})',
    languageMember: 'Vorlesesprache',
    languageMemberHint: 'Titel werden so vorgelesen, wie du sie eingibst.',
    languageFamily: 'Wie die Familie ({language})',
    saved: 'Gespeichert',
};
//# sourceMappingURL=readAloudApp.de.js.map